import { render, staticRenderFns } from "./StudioIntroduction.vue?vue&type=template&id=f9b1e16e&scoped=true"
import script from "./StudioIntroduction.vue?vue&type=script&lang=js"
export * from "./StudioIntroduction.vue?vue&type=script&lang=js"
import style0 from "./StudioIntroduction.vue?vue&type=style&index=0&id=f9b1e16e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b1e16e",
  null
  
)

export default component.exports